"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
function ZonaPPHero({
  title,
  className,
  children
}: {
  title: string;
  className?: string;
  children?: React.ReactNode;
}) {
  return <section id="strukturhierarkihero" className={`relative w-full bg-zinc-950 overflow-hidden min-h-[400px] flex items-center ${className}`}>
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/pp_members_hero_bg.webp)] bg-cover bg-center opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-zinc-950 via-zinc-950/80 to-zinc-950 md:bg-gradient-to-r md:from-zinc-950 md:via-zinc-950/90 md:to-transparent" aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 py-16 md:py-24">
        <div className="max-w-3xl">
          {children}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-white mt-6 leading-tight">
            {title}
          </h1>
        </div>
      </div>
    </section>;
}
export default function StrukturHierarkiHero() {
  return <ZonaPPHero title="Struktur & Hierarki" className="zona-pp-hero">
      <div className="zona-pp-breadcrumbs">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/PancasilaYouthZonePage" className="text-zinc-400 hover:text-white transition-colors">
                  Beranda Zona PP
                </Link>
              </BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator className="text-zinc-500" />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-white font-medium">
                Struktur & Hierarki
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </ZonaPPHero>;
}